<!-- Scan tugmasi — chaqiruvchida o'z tugmasi bo'lsa yashiriladi -->
@if (showTrigger) {
  <button
    type="button"
    (click)="startScan()"
    class="inline-flex items-center justify-center rounded-md h-11 w-11 border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors hover:cursor-pointer"
    [title]="'BARCODE_SCANNER.TRIGGER_TITLE' | translate"
  >
    <lucide-icon [img]="Camera" class="w-4 h-4 text-gray-600 dark:text-gray-400"></lucide-icon>
  </button>
}

@if (errorMsg()) {
  <p
    class="fixed bottom-4 left-1/2 z-[10000] max-w-[90vw] -translate-x-1/2 rounded-lg bg-red-600 px-3 py-2 text-center text-xs text-white shadow-lg"
  >
    {{ errorMsg() }}
  </p>
}

<!-- Skaner overlay -->
@if (isScanning()) {
  <div class="fixed inset-0 z-[9999] bg-black flex flex-col">
    <!-- Header -->
    <div class="flex items-center justify-between px-4 py-3 bg-black/80">
      <span class="text-white text-sm font-medium">{{
        'BARCODE_SCANNER.OVERLAY_TITLE' | translate
      }}</span>
      <button
        (click)="stopScan()"
        class="text-white p-1 rounded-full hover:bg-white/20 transition-colors"
      >
        <lucide-icon [img]="X" class="w-6 h-6"></lucide-icon>
      </button>
    </div>

    <!-- Video -->
    <div class="flex-1 relative overflow-hidden">
      <video
        #videoEl
        class="absolute inset-0 w-full h-full object-cover"
        autoplay
        playsinline
        muted
      ></video>

      <!-- Yo'naltiruvchi ramka -->
      <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div class="relative">
          <div class="w-72 h-40 border-2 border-white rounded-lg"></div>
          <!-- Burchak chiziqlari -->
          <div
            class="absolute -top-0.5 -left-0.5 w-8 h-8 border-t-4 border-l-4 border-yellow-400 rounded-tl-lg"
          ></div>
          <div
            class="absolute -top-0.5 -right-0.5 w-8 h-8 border-t-4 border-r-4 border-yellow-400 rounded-tr-lg"
          ></div>
          <div
            class="absolute -bottom-0.5 -left-0.5 w-8 h-8 border-b-4 border-l-4 border-yellow-400 rounded-bl-lg"
          ></div>
          <div
            class="absolute -bottom-0.5 -right-0.5 w-8 h-8 border-b-4 border-r-4 border-yellow-400 rounded-br-lg"
          ></div>
          <!-- Skanerlash chizig'i animatsiyasi -->
          <div class="absolute left-2 right-2 h-0.5 bg-yellow-400 animate-scan-line"></div>
        </div>
      </div>

      <!-- Overlay qoraytirish -->
      <div
        class="absolute inset-0 pointer-events-none"
        style="
          background: radial-gradient(
            ellipse 18rem 10rem at center,
            transparent 100%,
            rgba(0, 0, 0, 0.6) 100%
          );
        "
      ></div>
    </div>

    <p class="text-center text-white/70 text-xs pb-6 pt-3">
      {{ 'BARCODE_SCANNER.HINT' | translate }}
    </p>
  </div>
}
